module.exports = __webpack_public_path__ + "img/logo.699f2b47.svg";